<template>
  <div class="my_page">

    <div class="top_div">
        <!-- 顶部标题 -->
        <div class="page_title">座享乐舒</div>

        <!-- 用户信息 -->
        <div class="user_row">
            <div class="user_left">
                <div class="avatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" width="26" height="26">
                        <circle cx="12" cy="8" r="4"/>
                        <path d="M4 21c0-4 4-6 8-6s8 2 8 6"/>
                    </svg>
                </div>
                <div class="user_phone">{{ userPhone }}</div>
            </div>
            <div class="my_order_link" @click="goOrderList('first')">
                我的订单 <span class="arrow">›</span>
            </div>
        </div>

        <!-- Banner 区（背景用价格列表背景图） -->
        <div class="banner">
        </div>

        
    </div>

    <!-- 我的订单 -->
     <div  class="order_entry1">
        <div class="section_title">我的订单</div>
        <div class="order_entry">

        <div class="entry_item" @click="goOrderList('second')">
            <div class="entry_icon icon_using">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="28" height="28">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            </div>
            <div class="entry_label">使用中</div>
        </div>
        <div class="entry_item" @click="goOrderList('first')">
            <div class="entry_icon icon_done">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="28" height="28">
                <rect x="3" y="4" width="18" height="18" rx="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
                <polyline points="9 15 11 17 15 13"/>
            </svg>
            </div>
            <div class="entry_label">已完成</div>
        </div>
        </div>
    </div>

    <!-- 功能网格 -->
    <div class="func_grid">
      <!-- 第一行 -->
      <div class="func_item" @click="goHezuo">
        <div class="func_icon fi1">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        </div>
        <div class="func_label">商务合作</div>
      </div>
      <div class="func_item" @click="onFuncClick('sign')">
        <div class="func_icon fi2">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><polyline points="9 15 11 17 15 13"/></svg>
        </div>
        <div class="func_label">每日签到</div>
      </div>
      <div class="func_item" @click="goShouhou">
        <div class="func_icon fi3">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
        </div>
        <div class="func_label">售后客服</div>
      </div>
      <div class="func_item" @click="onFuncClick('user')">
        <div class="func_icon fi4">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        </div>
        <div class="func_label">用户服务</div>
      </div>

      <!-- 第二行 -->
      <div class="func_item2" @click="goFuwu">
        <div class="func_icon fi5">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/></svg>
        </div>
        <div class="func_label">用户服务协议</div>
      </div>
      <div class="func_item2" @click="goYinsi">
        <div class="func_icon fi6">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        </div>
        <div class="func_label">隐私政策协议</div>
      </div>
      <div class="func_item2" @click="onFuncClick('admin')">
        <div class="func_icon fi7">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="26" height="26"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
        </div>
        <div class="func_label">后台入口</div>
      </div>
    </div>

    <!-- 底部 TabBar -->
    <AdultNewTabBar />
  </div>
</template>

<script>
import AdultNewTabBar from '@/components/AdultNewTabBar.vue'

export default {
  name: 'NewPageMy',
  components: { AdultNewTabBar },
  data() {
    return {
      userPhone: '欢迎您使用！'
    }
  },
  methods: {
    // 手机号脱敏：136****8958
    // maskPhone(phone) {
    //   if (!phone) return ''
    //   return phone.length >= 11
    //     ? phone.slice(0, 3) + '****' + phone.slice(7)
    //     : phone
    // },
    goOrderList(tab) {
      this.$router.push({
        path: '/new-page-order-list',
        query: { tab: tab || 'first' }
      })
    },
    goYinsi() {
      this.$router.push('/new-page-yinsi')
    },
    goFuwu() {
      this.$router.push('/new-page-fuwu')
    },
    goHezuo() {
      this.$router.push('/new-page-hezuo')
    },
    goShouhou() {
      this.$router.push('/new-page-shouhou')
    },
    onFuncClick(type) {
      const map = {
        cooperate: '商务合作',
        sign: '每日签到',
        service: '售后客服',
        user: '用户服务',
        agreement: '用户服务协议',
        admin: '后台入口'
      }
      this.$message.info(map[type] + ' — 待开发')
    }
  }
}
</script>

<style scoped>
.my_page {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(180deg, #e8f1fa 0%, #f5f8fc 30%, #f5f8fc 100%);
  box-sizing: border-box;
  padding-bottom: 70px;
}

/* 页面标题 */
.page_title {
  text-align: center;
  padding: 20px 0 12px;
  font-size: 17px;
  font-weight: 700;
  color: #1a3c5e;
}

.top_div{
    background-size: cover;
    background-position: center;
    height: 30vh;
    position: relative;
    padding-top: 11%;
}

/* 用户信息行 */
.user_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px 0;
}
.user_left {
    display: flex;
    align-items: center;
    gap: 10px;
}
.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #5ca8e8, #2c6ba5);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #fff;
}
.user_phone {
    font-size: 15px;
    font-weight: 600;
    color: #1a3c5e;
    text-shadow: 0 1px 2px rgba(255,255,255,0.8);
}
.my_order_link {
    font-size: 13px;
    color: #2c6ba5;
    background: rgba(255,255,255,0.7);
    padding: 4px 10px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.my_order_link .arrow {
    font-size: 16px;
    font-weight: 300;
    margin-left: 2px;
}

/* Banner */
.banner {
    background-image: url('@/assets/new_adult_img/价格列表背景图.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    margin: 20px 16px 0;
    height: 110px;
    border-radius: 14px;
    backdrop-filter: blur(4px);
    padding: 0 20px;
    display: flex;
    align-items: center;
    overflow: hidden;
    position: relative;
}
.banner_text {
  display: flex;
  flex-direction: column;
  color: #fff;
}
.banner_t1 {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 3px;
}
.banner_t2 {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 3px;
  margin-top: 4px;
}
.banner_img {
  display: none;
}

/* 区块标题 */
.section_title {
  margin: 18px 16px 10px;
  font-size: 15px;
  font-weight: 700;
  color: #1a3c5e;
}

/* 订单双入口 */
.order_entry1 {
  margin: 16px 16px;
  background: #fff;
  border-radius: 14px;
  padding: 12px 10px;
  box-shadow: 0 2px 10px rgba(21, 101, 192, 0.06);
  height: 17vh;
}
.order_entry {
  margin: 0 16px;
  background: #fff;
  border-radius: 14px;
  padding: 18px 10px;
  display: flex;
  justify-content: space-around;
  /* box-shadow: 0 2px 10px rgba(21, 101, 192, 0.06); */
}
.entry_item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.entry_icon {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.icon_using {
  background: #fff3e0;
  color: #f5a623;
}
.icon_done {
  background: #e6f7e9;
  color: #4caf50;
}
.entry_label {
  font-size: 13px;
  color: #555;
}

/* 功能网格 */
.func_grid {
  margin: 0 16px;
  background: #fff;
  border-radius: 14px;
  padding: 18px 10px 22px;
  display: flex;
  flex-wrap: wrap;
  box-shadow: 0 2px 10px rgba(21, 101, 192, 0.06);
  margin-top: 3%;
}
.func_item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 18px;
  cursor: pointer;
}
.func_item2 {
  width: 33.33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 18px;
  cursor: pointer;
}
.func_icon {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
/* 各 icon 颜色 */
.fi1 { background: #e8f0fb; color: #2c6ba5; }
.fi2 { background: #fff3e0; color: #f5a623; }
.fi3 { background: #e6f7e9; color: #4caf50; }
.fi4 { background: #fce4ec; color: #e91e63; }
.fi5 { background: #f3e5f5; color: #9c27b0; }
.fi6 { background: #e0f7fa; color: #00acc1; }
.fi7 { background: #ede7f6; color: #5e35b1; }

.func_label {
  font-size: 12px;
  color: #555;
  text-align: center;
  line-height: 1.3;
}
</style>